import Vue from 'vue'
import VueX from 'vuex'
import createLogger from 'vuex/dist/logger'

import packages from './packages'
import subscribeKey from './subscribeKey'

Vue.use(VueX)

let plugins = []
if (process.env.NODE_ENV === 'development') {
  plugins.push(createLogger())
}

let store = new VueX.Store({
  modules: { packages },
  state: {
    token: null,
    name: 'Store',
    user: {}
  },
  mutations: {
    SET_TOKEN (state, token) { state.token = token },
    SET_USER (state, user) { Vue.set(state, 'user', user) }
  },
  actions: {
    IFRAME_SET_TOKEN ({commit}, token) { commit('SET_TOKEN', token) },
    IFRAME_SET_USER ({commit}, user) { commit('SET_USER', user) },
    IFRAME_PACKAGES_SELECTION ({ commit }, id) { commit('PACKAGES_SET_ACTIVE', id) },
    IFRAME_PACKAGES_INSTALLED ({ commit }, installed) { commit('PACKAGES_SET_INSTALLED', installed) },
    IFRAME_PACKAGES_IN_LOADING ({ commit }, inLoading) { commit('PACKAGES_SET_IN_LOADING', inLoading) },
    IFRAME_PACKAGES_LANGUAGE ({ commit }, language) { commit('PACKAGES_SET_LANGUAGE', language) }
  },
  plugins
})

store.subscribeKey = subscribeKey(store)

export default store
